module.exports = __webpack_public_path__ + "static/img/warehouse04.4236e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warehouse04.jpg
// module id = ZXKq
// module chunks = 0